import { TP_SERVER_DOMAIN } from '../config';
import request from './request';

/**
 * 查询代币安全信息
 */
export function reqTokenSecurity(params) {
    return request.get(`${TP_SERVER_DOMAIN}/v1/token/token_security_thirdparty`, {
        params,
    });
}

/**
 * 查询代币安全聚合信息
 */
export function reqTokenSecurityByGroup(params, options = {}) {
    return request.get(`${TP_SERVER_DOMAIN}/v1/token/token_security`, {
        params,
        signal: options.signal,
        timeout: options.timeout,
    });
}

/**
 *
 * @blockchain_id { Number } 链id
 * @contract_address { String } 代币地址
 * @bl_symbol { String } bl_symbol
 * @returns
 */
export function reqTokenInfo(params, options = {}) {
    return request.get(`${TP_SERVER_DOMAIN}/v1/token/info`, { params, timeout: options.timeout });
}

/** 批量获取代币信息
 * @blockchain_id { String } 账户地址
 * @token_list { Array } 代币列表
 * [
 *  { address: "0xB28005C6152890d6EfafA0CBfE722533A807bd74" }
 * ]
 */
export function reqTokenBatch(data) {
    return request.post(`${TP_SERVER_DOMAIN}/v1/token/batch`, data);
}
